var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageSuggestionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4965_28927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M16.4283 7.21339C16.4362 6.06591 16.1368 4.93722 15.5613 3.9445C14.9857 2.95178 14.1549 2.13123 13.1551 1.56801C12.1553 1.0048 11.023 0.719462 9.8757 0.741626C8.7284 0.763789 7.60795 1.09264 6.63066 1.69405C5.65338 2.29546 4.85488 3.14749 4.31808 4.1617C3.78127 5.17591 3.52572 6.31532 3.57795 7.46164C3.63019 8.60796 3.98831 9.7194 4.61513 10.6806C5.24196 11.6418 6.11463 12.4176 7.14257 12.9277V15.0705C7.14257 15.26 7.21782 15.4417 7.35178 15.5756C7.48573 15.7096 7.66741 15.7848 7.85685 15.7848H12.1426C12.332 15.7848 12.5137 15.7096 12.6476 15.5756C12.7816 15.4417 12.8569 15.26 12.8569 15.0705V12.9277C13.9247 12.4016 14.8246 11.5881 15.4555 10.5786C16.0864 9.56918 16.4233 8.40378 16.4283 7.21339V7.21339Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M7.14307 19.3562H12.8574",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    className: "icon-svg",
    id: "clip0_4965_28927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0704346)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSuggestionIcon);
export default __webpack_public_path__ + "static/media/ManageSuggestionIcon.f2b756db38882da8923cee4eca2ab0ec.svg";
export { ForwardRef as ReactComponent };